import * as XLSX from "xlsx";

export function downloadStaticReport(response) {
  const trainingData = response.map((data) => {
    return [
      data.title ?? "", // Training Title
      data.trainingTopic ?? "", // Training Topic
      data.trainingtype?.title ?? "", // Training Type
      data.trainerCount ?? "", // Venue
      data.traineeCount ?? "", // Venue
      data.noofdays ?? "", // Days
      data.thematic_id ?? "", // Thematic Area
      data.subprogram_id ?? "", // Subprogram
      data.project_id ?? "", // Project
      data.advisor_id ?? "", // Advisor
      data.programofficer_id ?? "", // Program Officer
      data.doner_id ?? "", // Doner
      data.startdate ?? "", // Start Date
      data.enddate ?? "", // End Date
      data.district_id ?? "", // Location
      data.venue ?? "", // Venue
    ];
  });

  const headers = [
    "Training Title",
    "Training Topic",
    "Training Type",
    "Trainers",
    "Trainees",
    "Days",
    "Thematic Area",
    "Subprogram",
    "Project",
    "Advisor",
    "Program Officer",
    "Doner",
    "Start Date",
    "End Date",
    "Location",
    "Venue",
  ];

  // Combine the headers with the training data
  const data = [headers, ...trainingData];

  // Create a new workbook
  const wb = XLSX.utils.book_new();
  // Add a worksheet with the data
  const ws = XLSX.utils.aoa_to_sheet(data);
  // Apply filter to the worksheet
  ws["!autofilter"] = {
    ref: "A1:P1",
  };
  // Append the worksheet to the workbook
  XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
  // Generate a blob from the workbook
  const wbout = XLSX.write(wb, {
    bookType: "xlsx",
    type: "array",
  });
  const blob = new Blob([wbout], {
    type: "application/octet-stream",
  });
  // Create a temporary anchor element to trigger the download
  const a = document.createElement("a");
  document.body.appendChild(a);
  a.style.display = "none";
  // Set the download URL and click the anchor to trigger the download
  const url = window.URL.createObjectURL(blob);
  a.href = url;
  a.download = "Statical Report.xlsx";
  a.click();
  // Cleanup
  window.URL.revokeObjectURL(url);
  document.body.removeChild(a);
}

export function downloadTraineeList(response) {
  const trainingData = response.map((data) => {
    return [
      data.name ?? "",
      data.email ?? "",
      data.gender ?? "",
      data.mobile ?? "",
      data.profession ?? "",
      data.designation?.title ?? "",
      data.department?.title ?? "",
    ];
  });

  const headers = [
    "Name",
    "Email",
    "Gender",
    "Contact No",
    "Profession",
    "Designation",
    "Department",
  ];

  // Combine the headers with the training data
  const data = [headers, ...trainingData];

  // Create a new workbook
  const wb = XLSX.utils.book_new();
  // Add a worksheet with the data
  const ws = XLSX.utils.aoa_to_sheet(data);
  // Apply filter to the worksheet
  ws["!autofilter"] = {
    ref: "A1:G1",
  };
  // Append the worksheet to the workbook
  XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
  // Generate a blob from the workbook
  const wbout = XLSX.write(wb, {
    bookType: "xlsx",
    type: "array",
  });
  const blob = new Blob([wbout], {
    type: "application/octet-stream",
  });
  // Create a temporary anchor element to trigger the download
  const a = document.createElement("a");
  document.body.appendChild(a);
  a.style.display = "none";
  // Set the download URL and click the anchor to trigger the download
  const url = window.URL.createObjectURL(blob);
  a.href = url;
  a.download = "Trainee List.xlsx";
  a.click();
  // Cleanup
  window.URL.revokeObjectURL(url);
  document.body.removeChild(a);
}

export function downloadTrainerList(response) {
  const trainingData = response.map((data) => {
    return [
      data.name ?? "",
      data.email ?? "",
      data.gender ?? "",
      data.mobile ?? "",
      data.profession ?? "",
      data.designation?.title ?? "",
      data.department?.title ?? "",
    ];
  });

  const headers = [
    "Name",
    "Email",
    "Gender",
    "Contact No",
    "Profession",
    "Designation",
    "Department",
  ];

  // Combine the headers with the training data
  const data = [headers, ...trainingData];

  // Create a new workbook
  const wb = XLSX.utils.book_new();
  // Add a worksheet with the data
  const ws = XLSX.utils.aoa_to_sheet(data);
  // Apply filter to the worksheet
  ws["!autofilter"] = {
    ref: "A1:G1",
  };
  // Append the worksheet to the workbook
  XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
  // Generate a blob from the workbook
  const wbout = XLSX.write(wb, {
    bookType: "xlsx",
    type: "array",
  });
  const blob = new Blob([wbout], {
    type: "application/octet-stream",
  });
  // Create a temporary anchor element to trigger the download
  const a = document.createElement("a");
  document.body.appendChild(a);
  a.style.display = "none";
  // Set the download URL and click the anchor to trigger the download
  const url = window.URL.createObjectURL(blob);
  a.href = url;
  a.download = "Trainer List.xlsx";
  a.click();
  // Cleanup
  window.URL.revokeObjectURL(url);
  document.body.removeChild(a);
}
